// extracted by mini-css-extract-plugin
export var image = "TableGrid-module--image--iJBUy";
export var wrapper = "TableGrid-module--wrapper--5mMYt";